import { FormHandles, SubmitHandler } from "@unform/core";
import React, { useContext, useEffect, useRef, useState } from "react";
import { Form } from '@unform/web'
import * as Yup from 'yup'
import { validateCNPJ, validateCPF } from 'validations-br';

import { ToastContext } from "../../contexts/toast/toastContext";
import Logo from "../../assets/imgs/logos/2025/alumisoft.svg";
import { ISolicitarAcesso } from "../../common/interfaces/solicitarAcesso.interfaces";
import { Input } from "../../components/Form";
import { getSingleErrorMessage } from "../../helpers/getSingleErrorMessage";
import getValidationErrors from "../../helpers/getValidateErrors";
import api from "../../services/api";
import { BsFillKeyFill } from "react-icons/bs";


const SolicitarAcesso: React.FC = () => {

    const formRef = useRef<FormHandles>(null);
    const [loading, setLoading] = useState(false);
    const toastContext = useContext(ToastContext);


    const schema = Yup.object().shape({
        email: Yup
                .string()
                .email("Digite um e-mail valido")
                .required('O e-mail é obrigatório.'),

        cnpj: Yup
                .string()
                .required('CNPJ ou CPF é obrigatório.')
                .test("is-valid",
                    "CNPJ ou CPF inválido",
                    (value: string | undefined) => {
                        if (!value) {
                            return false;
                        }
                        const cleanValue = value.replace(/\D/g, ''); // Remove non-digit characters
        
                        if (cleanValue.length === 11) {
                            return validateCPF(cleanValue);
                        } else if (cleanValue.length === 14) {
                            return validateCNPJ(cleanValue);
                        } else {
                            return false;
                        }
                    }
                ),
      });

    useEffect(() =>{
        formRef.current?.setErrors({});

    });

    const handleSubmit: SubmitHandler<ISolicitarAcesso> = async (form) => {
        try{
            setLoading(true);

            form.cnpj = form.cnpj.replaceAll(".", "").replace("/", "").replace("-", "");
            await schema.validate(form, { abortEarly: false })
            var response:any = await api.post("acesso/solicitar-acesso", form)
            .catch(error => {
                if (error.response) {
                    toastContext.notification("Não foi possível concluir a ação", "Aviso");
                };
            });
             
            if(response.data)
                toastContext.notification("Solicitação concluida com sucesso, por favor verifique sua caixa de e-mail", "success");
            else
                toastContext.notification("Solicitação de acesso em análise, entraremos em contato por e-mail", "success");
        }catch(error: any){
            if (error instanceof Yup.ValidationError)
            {
                toastContext.notification(error.errors, "error");
                formRef.current?.setErrors(getValidationErrors(error));
            }
            else
            {
                toastContext.notification(getSingleErrorMessage(error), "error");
            }  
        }finally{
            setLoading(false);
        }
    }
    
    return (
        <>
           <div className="pb-5">
            <header className="navbar navbar-eg navbar-expand-md pb-2">
                <div className="container-xl px-3">
                    <a className="navbar-brand navbar-brand-autodark d-none-navbar-horizontal pr-0 pr-md-4">
                        <img
                            src={Logo}
                            height="32"
                            className="navbar-brand-image"
                        />
                    </a>
                </div>
            </header>
        </div>

        <div className="container d-flex justify-content-center">
            <Form className="card" style={{ width: "100%", maxWidth: "600px", padding: "20px" }} ref={formRef} onSubmit={handleSubmit}>
                <p className="text-center pt-3 pb-3">
                    Seja bem-vindo(a) ao Portal do cliente<br/>
                    Informe os dados solicitados abaixo para seguir com a solicitação de acesso
                </p>
                <div className="mt-3">
                    <label className="form-label">E-mail</label>
                    <Input type="email" name="email" className="form-control" placeholder="Informe o e-mail cadastrado " />
                    <span>{}</span>
                </div>
                
                <div className="mt-3">
                    <label className="form-label">CNPJ/CPF</label>
                    <Input mask="cnpj" type="text" name="cnpj" className="form-control" placeholder="Informe o CNPJ ou CPF cadastrado" />
                </div>

                <div className="mt-3">
                    <button type="submit" className={"btn btn-primary btn-block" + (loading ? " disabled" : "")}>
                        {loading ? "Enviando..." : "Solicitar Acesso ao Sistema"}
                        <BsFillKeyFill className="ml-2"/>
                    </button>
                </div>
            </Form>
        </div>

        </>
    )
}

export default SolicitarAcesso;
